import EditBookingModal from './EditBookingModal';
export default EditBookingModal;